import {
  Avatar,
  CellHeader,
  CellList,
  CellSimple,
} from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

const AVATAR_URL =
  "https://sun9-67.userapi.com/s/v1/ig2/CY_xDesKnMtl0OiJynK0oc7QnxQVJUgeciJSi_MpZUiE3EHSCNltr76jugXaygGd2Xh0M8-61v7Jwfl1kO87YWVe.jpg?quality=95&crop=0,0,1440,1440&as=32x32,48x48,72x72,108x108,160x160,240x240,360x360,480x480,540x540,640x640,720x720,1080x1080,1280x1280,1440x1440&ava=1&u=SpmuDKJYdLKKRYYDgjLVQdEn6QnBonR3kSYxCSkCnm4&cs=200x200"

const AFTER_MAP = {
  none: undefined,
  Text: <span style={{ fontSize: 14 }}>Edit</span>,
  Icon: <PlaceholderIcon />,
}

export const CellHeaderExample = {
  title: "CellHeader",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [
    {
      name: "children",
      label: "children",
      type: "text",
      tsType: "string",
      default: "Пользователь",
    },
    {
      name: "titleStyle",
      label: "titleStyle",
      type: "enum",
      tsType: ['"normal"', '"caps"'],
      default: "caps",
      options: ["normal", "caps"],
    },
    {
      name: "fullWidth",
      label: "fullWidth",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
    {
      name: "innerClassNames",
      label: "innerClassNames",
      type: "static",
      tsType: "InnerClassNamesProp<CellHeaderInnerElementKey>",
      value: "-",
    },
    {
      name: "after",
      label: "after",
      type: "select",
      tsType: "ReactNode",
      default: "none",
      options: [
        { value: "none", label: "None" },
        { value: "Text", label: "Text" },
        { value: "Icon", label: "Icon" },
      ],
    },
  ],

  Preview({ props }) {
    return (
      <CellList
        header={
          <CellHeader
            after={AFTER_MAP[props.after]}
            fullWidth={props.fullWidth}
            titleStyle={props.titleStyle}
          >
            {props.children}
          </CellHeader>
        }
        mode="island"
      >
        <CellSimple
          before={
            <Avatar.Container size={40}>
              <Avatar.Image src={AVATAR_URL} />
            </Avatar.Container>
          }
          onClick={() => {}}
          showChevron
          title="Vadim Tregubenko"
        />
      </CellList>
    )
  },

  getCode(props) {
    const headerProps = []
    if (props.titleStyle !== "normal")
      headerProps.push(` titleStyle="${props.titleStyle}"`)
    if (props.fullWidth) headerProps.push(" fullWidth")
    if (props.after && props.after !== "none")
      headerProps.push(` after={<${props.after === 'Text' ? 'span' : 'Icon20Placeholder'} />}`)

    const headerPropsStr =
      headerProps.length > 0 ? headerProps.join("") : ""
    return `<CellList
  header={<CellHeader${headerPropsStr}>${props.children}</CellHeader>}
  mode="island"
>
  <CellSimple
    before={<Avatar.Container size={40}><Avatar.Image src="…" /></Avatar.Container>}
    onClick={() => {}}
    showChevron
    title="Vadim Tregubenko"
  />
</CellList>`
  },
}